import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 0 }
  }

  connect() {
    if (this.dismissAfterValue > 0) {
      this.timeoutId = window.setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }
  }

  disconnect() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
    }
  }

  dismiss() {
    const wrapper = this.element.parentElement
    this.element.remove()
    if (wrapper?.classList.contains("app-flash-messages") && !wrapper.querySelector(".notification")) {
      wrapper.remove()
    }
  }
}
